import React from 'react'
import { ImportBatchFiles } from '~/components/ImportBatchFiles'

export const DialogView = () => (
  <>
    <ImportBatchFiles />
  </>
)
